<template>
    <div class="x-tablelist-view api-code">
      <!-- 搜索行 -->
      <ux-searchOption
        :layout="layout"
        :data="filter"
        @input="search"
        @search="search"
        @add="showAdd"
        @resetsearch="resetsearch"
      ></ux-searchOption>
      <!-- 表格 -->
      <div class="x-table-box">
        <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :emptyText="$t('HT.nodata')"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
      </div>
    </div>
  </template>
  <script>
  import addApply from './template/addApply';
  export default {
    components: {
        addApply
    },
    data() {
      return {
        layout: [
          // 搜索项配置
          {
            type: 'input',
            key: 'serviceName',
            placeholder: this.$t('HT.pleaseInput')+this.$t('HT.advancedService.serviceName')
          },
          {
            type: 'button',
            text: this.$t('HT.reset'),
            plain: true,
            event: 'resetsearch'
          },
          {
            type: 'button',
            right: true,
            text: this.$t('HT.add'),
            icon: 'ux_icon_plus',
            hidden: !this.$hasModule(93),
            event: 'add'
          }
        ],
        columns: [
          // 表头数据
          {
            label: this.$t('HT.advancedService.serviceName'),
            prop:'serviceName',
            tooltip: true,
            align: 'left',
          },
          {
            label: this.$t('HT.advancedService.serviceCode'),
            prop: 'serviceCode',
            tooltip: true,
            align: 'left',
            sortable: true
          },
          {
            label: this.$t('HT.advancedService.serviceType'),
            prop: 'serviceType',
            align: 'left',
            tooltip: true
          },
          {
            label: this.$t('HT.advancedService.vendor'),
            prop: 'vendor',
            tooltip: true,
            align: 'left',
            sortable: true
          },
          {
            label: this.$t('HT.createdTime'),
            prop: 'createTime',
            tooltip: true,
            align: 'left',
            sortable: true
          },
          {
            label: this.$t('HT.remark'),
            prop: 'serviceDesc',
            maxWidth: 300,
            tooltip: true,
            align: 'left',
            sortable: true
          },
          {
            label: this.$t('HT.operation'),
            hidden: !this.$hasModule(93),
            align: 'left',
            render: (h, params) => {
              return h('my-table-btn', {
                props: {
                  data: [this.$t('HT.edit'), this.$t('HT.delete')],
                  colors: ['#0087ff', '#F45C5C'],
                  event: ['edit', 'del']
                },
                on: {
                  edit: () => {
                    this.showEdit(params);
                  },
                  del: () => {
                    const title=this.$t('HT.delete')+this.$t('HT.router.service')
                    const content=this.$t('HT.advancedService.delete.service')
                    this.$uxModal.show({
                      title,
                      content,
                      confirm: () => {
                        this.delList(params);
                      }
                    });
                  }
                }
              });
            }
          }
        ],
        filter: {
          // 查询参数
          page: 1,
          size: 10,
          serviceName: ''
        },
        tableData: {
          // 表格数据
          totalSize: 0,
          list: []
        }
      };
    },
    created() {
      this.getList(this.filter);
    },
    methods: {
      /**
       * 搜索
       */
      search() {
        this.filter.page = 1;
        this.getList(this.filter);
      },
      /**
       * 获取列表
       * @param {Object} params 请求参数
       */
      getList(params) {
        this.$uxLoading.show();
        this.$api.advancedService.getServiceList(params).then((res) => {
          if (res.code == 10000) {
            this.tableData = {
              totalSize: res.total_size,
              list: res.data
            };
          }
        });
      },
      /**
       * 重置搜索项
      */
      resetsearch() {
        this.filter.serviceName = '';
        this.search();
      },
      /**
       * 添加列表
       * @param {Object} params 表单提交参数
       */
      async addList(params) {
        this.$uxLoading.show();
        const {code,data}=await this.$api.advancedService.createService(params)
        if (code === 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
            this.getList(this.filter);
        }
      },
  
      /**
       * 修改列表
       * @param {Object} params 表单提交参数
       */
      async putList(params) {
        this.$uxLoading.show();
        const {code,data}=await this.$api.advancedService.updateService(params)
        if (code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
            this.getList(this.filter);
          }
      },
  
      /**
       * 删除列表
       * @param {String} id 唯一标识
       */
      async delList({id,serviceCode}) {
        this.$uxLoading.show();
        const {code,data}=await this.$api.advancedService.removeService({id,serviceCode})
        if (code === 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            if (this.tableData.list.length === 1) {
              this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
            }
            this.getList(this.filter);
        }
      },
  
      /**
       * 新增-弹窗
       */
      showAdd() {
        const title = this.$t('HT.imeiInput.add')+this.$t('HT.router.service');
        this.$uxModal.show({
          title,
          content: (h) => {
            return h(addApply, {
              on: {}
            });
          },
          confirm: (data) => {
            this.addList(data);
          }
        });
      },
  
      /**
       * 编辑
       * @param {Object} params 单行表格数据
       */
      showEdit(params) {
        const title = this.$t('HT.edit')+this.$t('HT.router.service');
        this.$uxModal.show({
          title,
          content: (h) => {
            return h(addApply, {
              props: { data: params },
              on: {}
            });
          },
          confirm: (data) => {
            this.putList(data);
          }
        });
      },
  

  
      /**
       * 搜索
       */
      seach() {
        this.filter.page = 1;
        this.getList(this.filter);
      },
  
      /**
       * 改变页容量
       * @param {Number} size 选择的页容量
       */
      changeSize(size) {
        this.filter.size = size;
        this.filter.page = 1;
        this.getList(this.filter);
      },
      /**
       * 改变页码
       * @param {Number} page 选择的页码
       */
      changePage(page) {
        this.filter.page = page;
        this.getList(this.filter);
      }
    }
  };
  </script>
  <style lang="scss" scoped>
     .ux-search-option{
      z-index: 10;
     }
  </style>